import '~/globals.js'
import orgPicker from '~/packs/lmdr/organisation_picker';
import datePicker from '~/packs/droom/date_picker';
import popupOnClick from '~/packs/droom/popups';
import panel from '~/packs/droom/panels';
import actionMenu from '~/packs/droom/menus';
import loginForm from '~/packs/droom/login';
import detacher from '~/packs/lmdr/detacher';
import { totalizer, oneliner } from '~/packs/lmdr/serials';
import { imagePicker, singleImagePicker } from '~/packs/lmdr/image_picker';
import { filePicker, csvFilePicker } from '~/packs/lmdr/file_picker';
import { processionUploadTable } from '~/packs/lmdr/procession_upload';

import { addSelectorActivation } from '~/packs/droom/activate';
import { facetingSearch } from '~/packs/droom/captives';
import { refresher, reloader } from '~/packs/droom/refreshers';
import { passwordFieldset } from '~/packs/droom/passwords';
import { registerForm } from '~/packs/droom/registration';
import {
    revealer,
    appendsFields,
    removesFields,
    subordinateField,
    statusForm,
    activePlaceholder
} from '~/packs/droom/helpers';
import { titleBubble, infoWindow } from '~/packs/droom/bubbles';

/* Add control room element-activators to the existing set */

addSelectorActivation('revealer', '[data-reveals]', revealer);
addSelectorActivation('image_picker', '[data-role="imagepicker"]', imagePicker);
addSelectorActivation('single_image_picker', '[data-role="singleimagepicker"]', singleImagePicker);
addSelectorActivation('org_picker', '[data-role="orgpicker"]', orgPicker);
addSelectorActivation('file_picker', '[data-role="filepicker"]', filePicker);
addSelectorActivation('csv_file_picker', '[data-role="csvfilepicker"]', csvFilePicker);
addSelectorActivation('procession_upload', '[data-role="processionupload"]', processionUploadTable);
addSelectorActivation('date_picker', '[data-role="datepicker"]', datePicker);
addSelectorActivation('popup_on_click', '[data-popup],[data-action="popup"]', popupOnClick);
addSelectorActivation('panel', 'div[data-panel]', panel);
addSelectorActivation('password_fieldset', 'fieldset[data-role="password"]', passwordFieldset);
addSelectorActivation('appends_fields', '[data-action="append_fields"]', appendsFields);
addSelectorActivation('removes_fields', '[data-action="remove_fields"]', removesFields);
addSelectorActivation('subordinate_field', '[data-dependent]', subordinateField);
addSelectorActivation('refresher', '[data-refreshing]', refresher);
addSelectorActivation('reloader', '[data-reloading]', reloader);
addSelectorActivation('action_menu', '[data-menu]', actionMenu);
addSelectorActivation('status_form', 'form[data-role="status"]', statusForm);
addSelectorActivation('login_form', 'form.login', loginForm);
addSelectorActivation('registration_form', 'form.register', registerForm);
addSelectorActivation('faceting_search', 'form.search_and_facet', facetingSearch);
addSelectorActivation('oneliner', '[data-role="oneliner"]', oneliner);
addSelectorActivation('totalizer', '[data-role="totalizer"]', totalizer);
addSelectorActivation('title_bubble', 'label[title]', titleBubble);
addSelectorActivation('detacher', 'fieldset[data-detachable]', detacher);
addSelectorActivation('infowindow', '[data-infowindow]', infoWindow);
addSelectorActivation('placeholderer', 'input[data-activeplaceholder]', activePlaceholder);
